export const VACANCIES_MODES = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
};
